import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
const faqs = [{
  question: '¿Necesito seguidores?',
  answer: 'No. Solo necesitas una oferta clara. El programa te enseña a vender sin depender de una audiencia masiva.'
}, {
  question: '¿Necesito saber grabar videos?',
  answer: 'No. Te enseñamos una estructura simple que no requiere equipos costosos ni habilidades avanzadas de edición.'
}, {
  question: '¿Cuánto tiempo diario necesito?',
  answer: 'Entre 60 y 90 minutos al día es suficiente para completar el programa en 15 días.'
}, {
  question: '¿Funciona en cualquier país?',
  answer: 'Sí, el sistema es aplicable globalmente siempre que tengas acceso a internet y redes sociales.'
}, {
  question: '¿Qué tipo de productos puedo crear?',
  answer: 'Programas, guías, ebooks, retos, mini cursos, mentorías y más. Te ayudamos a elegir el mejor formato para ti.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-[#050510]" data-id="element-31">
      <div className="container mx-auto max-w-3xl" data-id="element-32">
        <ScrollReveal className="text-center mb-12" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-34">
            Preguntas Frecuentes
          </h2>
        </ScrollReveal>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <ScrollReveal key={index} delay={index * 0.1} data-id="element-36">
              <div className="glass-card rounded-xl overflow-hidden border border-white/5" data-id="element-37">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-38">
                  <span className="font-bold text-lg text-white" data-id="element-39">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
                </button>
                <AnimatePresence data-id="element-41">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-42">
                      <div className="p-6 pt-0 text-gray-400 border-t border-white/5" data-id="element-43">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}